import React from 'react';
import { Container } from '../../../../components/Container';
import { StatesColumnList } from './StatesColumnList';
import { Typography } from '../../../../components/Typography';
import statesMap from '../../../../assets/images/states-map.svg';
import { LazyImage } from '../../../../wag-react/components/lazyload/LazyImage';
import { Box } from '../../../../wag-react/next-components/box';
export const HealthStatesSection = () => <Container pb={['64px', '80px']} pt={['80px', '96px', '72px']} data-sentry-element="Container" data-sentry-component="HealthStatesSection" data-sentry-source-file="index.tsx">
    <Box maxWidth={['100%', null, '50%']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Typography color="medGray" m={0} textAlign={['left']} variant="h2" width={1} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Find a trusted Pet Caregiver near you
      </Typography>
      <Typography color="medGray" fontWeight="400" mb={[0, '40px']} mt={['16px', '24px']} textAlign={['left']} variant="h3" width={1} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Available in 5,300 cities across all 50 states
      </Typography>
      <LazyImage src={statesMap} height="306px" width={[1, null, '532px']} imageProps={{
      style: {
        objectFit: 'unset'
      }
    }} data-sentry-element="LazyImage" data-sentry-source-file="index.tsx" />
      <StatesColumnList mt={['32px', '40px']} data-sentry-element="StatesColumnList" data-sentry-source-file="index.tsx" />
    </Box>
  </Container>;